const styles = {
  global: {
    body: {
      color: 'text.main',
    },
    label: {
      fontSize: '14px!important',
      fontWeight: 'normal!important',
    },
  },
};

export default styles;
